import { SingleActionConfig } from "../SingleActionConfig";
import { ExpandedAction } from "../../Action";

export abstract class NonDatabaseActionActionConfig extends SingleActionConfig {
  protected constructor(action: ExpandedAction) {
    super(action, [], false);
  }
  getClickPhrase = () => "";
}
